<template>
  <div id='selloutPage'>
	
		    <div class='selloutBox'>
		          <div class='selloutBoxtop' v-if='goodsMsg.msgCode==3'>
		              <div class='selloutBoxName'>{{goodsMsg.msg}}</div>
		              <div class='selloutBoxTxt' style='text-align: center;'>
							<span v-for='item in goodsMsg.msgArr'>{{item.goods_name}},  </span>
					  </div>  
		          </div>
		          <div class='selloutBoxtop' v-if='goodsMsg.msgCode==2'>
		              <div class='selloutBoxName' style="text-align: left;">{{goodsMsg.msg}}</div>
		              <div class='selloutBoxTxt' style="text-align: left;">
		                  <div style='margin-bottom:29rpx;'>你可以选择直接购买并等待发货，或选择删除这些产品并下单</div>
		              <div  style='max-height:2.2rem;overflow-y: auto;text-align: left;'>
		                <div v-for='item in goodsMsg.msgArr' class='selloutBoxTxtName'>{{item.goods_name}}：<span>{{item.reason}}</span></div>  
		              </div>
		              </div>  
		          </div> 
		          <div class='selloutBtn'>
						<div @click="cancelSellout" v-if='goodsMsg.msgCode==3'>取消</div>
		                <div @click='delAndBuy'>删除并下单</div>
						<div @click="goOnCreateOrder" v-if='goodsMsg.msgCode==2'>购买（稍后发货）</div>
		          </div>
		    </div>
		    <div class='sellloutCover' @click="handlerNull"></div>
		
       
        
  </div>
</template>

<script>
export default {
  name: 'GoodsShortage',
  props: {
    goodsMsg: Object,
  },
  data:function(){
    return{
      message:"",
      placeholderTxt:"请输入…"
    }
  },
 
 created:function(){
    console.log(this.goodsMsg)
  },
  watch:{
    goodsMsg:{
        handler(newValue, oldValue) {
　　　　　
　　　　},
    }
  },
  methods: {
   
	// 关闭提示
    closeSellout(){ 
			 //传递给父组件
            this.$emit('selloutShowFN',false)   
	},
	// 点击取消
	cancelSellout(){
		this.closeSellout()
		this.$parent.cancelCreateOrder() 
	},
	//继续下单预售商品
	goOnCreateOrder(){
			//使用父组件的方法
			this.$parent.toMadeOrderPage(this.goodsMsg.cart_ids,true)      
	},
	// 删除并下单
	delAndBuy(){
			let _goods_ids=[]     							//商品id数组
		    let _cart_ids = this.goodsMsg.cart_ids       	//橘袋id数组
		    this.goodsMsg.msgArr.forEach((item)=>{
		      _goods_ids.push(item.goods_id)
		    })
			this.delCartsGoods(_cart_ids, _goods_ids)
	},
	// 从橘袋中删除缺货商品
	delCartsGoods(cart_ids, goods_ids){
		let that = this
		this.axios({
		            method: 'post',
		            url:"Allcart/delCartGoodsAll",
		            data:{
						member_id:this.$store.state.member_id,
						cart_ids: cart_ids,
						goods_ids: goods_ids,
		            }
		    }).then(res=>{
				this.closeSellout()
				console.log(res.data.cart_ids)
				
				this.$parent.toCreateOrder(res.data.cart_ids)      //使用父组件的方法
			})
	},
	handlerNull(){},
  }
}
</script>  

<style>
	#selloutPage{
	  position: fixed;
	  width: 7.5rem;
	  height: 100vh;
	  top:0;
	  left: 0;

	  font-family:PingFangSC;
	  z-index: 200;
	  left:50%;
	  transform: translate(-50%,0); 
	}
	.sellloutCover{
	  width: 7.5rem;
	  height: 100vh;
	  background: rgba(0, 0, 0, 0.5);
	}
	
	.selloutBox{
	  width: 6.5rem;
	  position: absolute;
	  left: 0.5rem;
	  top:50%;
	  transform: translate(0, -50%);  
	  background-color: #fff;
	  border-radius: 0.2rem;
	  z-index: 202;
	}
	.selloutBoxtop{
	  padding: 0 0.5rem 0.5rem;
	}
	.selloutBoxName{
	  min-height: 1rem;
	  line-height: 1rem;
	  text-align: center;
	  font-size: 0.34rem;
	  color: #333333;
	  font-family:PingFangSC-Medium,PingFang SC;
	  font-weight:bold;
	  
	}
	.selloutBoxTxtName{
	  color: rgba(0, 0, 0, 1);
	}
	.selloutBoxTxt{
	  font-size: 0.24rem;
	  font-family:PingFangSC-Regular,PingFang SC;
	  font-weight:400;
	  line-height: 0.4rem;
	  color: #787878;
	}
	.selloutBoxTxt span{
	  color:rgba(0, 0, 0, 0.6);
	}
	.selloutBtn{
	  display: flex;
	  padding: 0.2rem 0;
	  border-top: 0.01rem solid #BBBBBB;
	}
	.selloutBtn div{
	  width: 3.25rem;
	  text-align: center;
	  height:0.48rem;
	  line-height: 0.48rem;
	  border-right: 1px solid #BBBBBB;
	  font-family:PingFangSC-Medium,PingFang SC;
	  font-weight:400;
	  color: #666666;
	}
	.selloutBtn div:last-child{
	  border-right: none;
	}
</style>